import axios from "axios"
import { Upload, Button, Spin } from "antd"
import { UploadOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react"
import { success, warning } from "../../../helpers/alert"
import { getDocumentAws, setDocument } from "../../../helpers"
import { useAuth } from "../../../contexts/auth"
import { useMutation } from "@apollo/client"
import { createDownloadLog } from "../../../graphql/submission/mutations/createDownloadLog"

export function UploadButton({
  children,
  className,
  disabled,
  typeFile,
  files = [],
  onDoneFile,
  onRemoveFile,
  maxFile = 1,
  multiple = false
}) {
  const isDisabled = files?.length >= maxFile
  const [fileList, setFileList] = useState(files)
  const [filesUrls, setFilesUrls] = useState(files)
  const [uploading, setUploading] = useState(false)
  

  useEffect(() => {
    setFileList(files)
  }, [files])

  const findAndDelete = file => {
    const index = fileList.indexOf(file)
    const newFileList = fileList.slice()
    newFileList.splice(index, 1)
    setFileList(newFileList)
  }

  const uploadProps = {
    fileList,
    multiple,
    onRemove(file) {
      if (disabled) return false
      onRemoveFile(file, (err, refetch = () => null) => {
        if (err) {
          warning("Hubo un error al eliminar el documento")
        } else {
          success("Documento eliminado correctamente")
          findAndDelete(file)
          refetch()
        }
      })
    },
  }

  const onUploadChange = async (Archivo) => {

    let List = [...fileList.slice(), Archivo]
    List = List.slice(-maxFile)
    
    setFileList( List )
    setUploading(false)
  }

  const setAws = async (file) => {
    setUploading(true)

    const response = await setDocument(file)
    onUploadChange(response)
    onDoneFile?.(response, "done", typeFile)
  }

  const auth = useAuth()
  const userAuthDownload = auth?.user?.claims ?? {}

  /** Function to register data of downloaded documents **/

  const handleDownload = ( file ) => {

    getDocumentAws(file.url)

    if (!userAuthDownload) {
      console.error("No user information available")
      return
    }

    const downloadInfo = {
      email: userAuthDownload.email,
      userName: userAuthDownload.name,
      role: userAuthDownload.role,
      uid: userAuthDownload.user_id,
      documentName: file.name,
      type: file.type
    }

    trackDownload({
      variables: { data: downloadInfo }
    })
      .catch((error) => {
        console.error(error)
      })
  }

  const [trackDownload] = useMutation(createDownloadLog)

 
  return (
    <>
    <Upload
      className={className}
    //  data={getDataParams}
      beforeUpload={async (file) => {
       
        const uploadedFile = await setAws(file);

        if (!uploadedFile) return false;
        return false
      }}
      onPreview={(file) => {
        handleDownload(file)
      }}
      showUploadList={{
        showRemoveIcon: !disabled,
        itemRender: (originNode, file) => (
          <div
        style={{ cursor: "pointer", color: "#612F5E" }}
        onClick={(event) => {
          event.preventDefault(); 
          handleDownload(file);
        }}
      >
        {file.name}
      </div>
        ),
      }}
      {...uploadProps}>
      {(!disabled && !isDisabled) && (
        <Button 
          disabled={disabled || isDisabled}
          style={{ backgroundColor: "#612F5E", color: "#fff"}
           }>
          <UploadOutlined /> {children}
        </Button>
      )}
    </Upload>
    {uploading && 
         <div className="project-loading">
              <Spin tip="Subiendo Archivo"/>
          </div>
    }
    </>
  )
}
